import { OptionsType } from './index';
import { CucinaIcon, SalaIcon, BarIcon, ReceptionIcon } from '../';

export enum quickFilterIcons {
  sala = 'SalaIcon',
  cucina = 'CucinaIcon',
  bar = 'BarIcon',
  reception = 'ReceptionIcon',
}

export const domainInterestOptions: OptionsType[] = [
  {
    key: 'sala',
    id: '',
    label: 'Sala',
    icon: quickFilterIcons.sala,
    iconElement: ({ ...rest }) => <SalaIcon {...rest} />,
  },
  {
    key: 'cucina',
    id: '',
    label: 'Cucina',
    icon: quickFilterIcons.cucina,
    iconElement: ({ ...rest }) => <CucinaIcon {...rest} />,
  },
  {
    key: 'bar',
    id: '',
    label: 'Bar',
    icon: quickFilterIcons.bar,
    iconElement: ({ ...rest }) => <BarIcon {...rest} />,
  },
  {
    key: 'reception',
    id: '',
    label: 'Hotellerie',
    icon: quickFilterIcons.reception,
    iconElement: ({ ...rest }) => <ReceptionIcon {...rest} />,
  },
];
